enum NotificationType {
  BANK_ACCOUNT_NEGATIVE_BALANCE = "bank_account.negative_balance",
  TRANSACTION_SOURCE_OF_FUNDS_MISSING = "transaction.source_of_funds_missing",
  TRANSACTION_FUNDS_FOR_AFFILIATE_OWNER = "transaction.funds_for_affiliate_owner",
  COMPLIANCE_TRACKING_DOCUMENTS_REJECTED = "compliance_tracking.documents_rejected",
  COMPLIANCE_TRACKING_DOCUMENTS_MISSING = "compliance_tracking.documents_missing",
  REPORT_GENERATED = "report.generated",
  TRANSACTION_FLEXPSP_CREATE_WITHDRAW = "transaction.flexpsp_create_withdraw",
}

export { NotificationType };
